export default {
  $_veeValidate: {
    validator: 'new'
  },

  methods: {
    async validate () {
      const result = await this.$validator.validate()

      return result
    }
  }
}
